import { createFileRoute } from '@tanstack/react-router'
import { GruposEmpresariaisPage } from '@/pages/grupos-empresariais/GruposEmpresariaisPage'

export const Route = createFileRoute('/_auth/grupos-empresariais')({
  component: GruposEmpresariaisPage,
})
